import {PureComponent} from 'react'

import OffersExamples from './OffersExamples.jsx'

import './OffersExamples.scss'

export default class OffersExamplesPurchase extends PureComponent {
  render() {
    const title = "Achats : nos exemples de missions"
    const description = "Retrouvez les différents types de missions Achat déjà postés sur notre plateforme : management de transition, interim management, groupe international, ETI, etc."

    return <OffersExamples
      helmet={{title, description}}
      universeCode="purchase"
      title="Les missions Achats que vous auriez pu recevoir :"
    />
  }
}
